import * as echarts from 'echarts';

let mapData = require('./china.json');
let data = [{
    name: "北京",
    value: 177
},
{
    name: "天津",
    value: 42
},
{
    name: "河北",
    value: 102
},
{
    name: "山西",
    value: 81
},
{
    name: "内蒙古",
    value: 47
},
{
    name: "辽宁",
    value: 67
},
{
    name: "吉林",
    value: 82
},
{
    name: "黑龙江",
    value: 66
},
{
    name: "上海",
    value: 24
},
{
    name: "江苏",
    value: 92
},
{
    name: "浙江",
    value: 114
},
{
    name: "安徽",
    value: 109
},
{
    name: "福建",
    value: 116
},
{
    name: "江西",
    value: 91
},
{
    name: "山东",
    value: 119
},
{
    name: "河南",
    value: 137
},
{
    name: "湖北",
    value: 116
},
{
    name: "湖南",
    value: 114
},
{
    name: "重庆",
    value: 91
},
{
    name: "四川",
    value: 125
},
{
    name: "贵州",
    value: 62
},
{
    name: "云南",
    value: 83
},
{
    name: "西藏",
    value: 9
},
{
    name: "陕西",
    value: 80
},
{
    name: "甘肃",
    value: 56
},
{
    name: "青海",
    value: 10
},
{
    name: "宁夏",
    value: 18
},
{
    name: "新疆",
    value: 67
},
{
    name: "广东",
    value: 123
},
{
    name: "广西",
    value: 59
},
{
    name: "海南",
    value: 14
},
];
let geoCoordMap = {};
let geoData = [
	{
		name: "京津冀城市群",
		value: 999,
		color:[{
			offset: 0, color: 'rgba(233,105,105,0.1)' // 0% 处的颜色
		},{
			offset: 0.2, color: 'rgba(233,105,105,0.5)' // 20% 处的颜色
		}, {
			offset: 0.5, color: 'rgba(233,105,105,0.7)' // 50% 处的颜色
		}, {
			offset: 0.51, color: 'rgba(233,105,105,0.5)' // 51% 处的颜色
		}, {
			offset: 1, color: 'rgba(233,105,105,0.5)' // 100% 处的颜色
		}],
	},
	{
		name: "成渝经济圈",
		value: 999,
		color: [{
			offset: 0, color: 'rgba(231,177,231,0.1)' // 0% 处的颜色
		},{
			offset: 0.2, color: 'rgba(231,177,231,0.5)' // 20% 处的颜色
		}, {
			offset: 0.5, color: 'rgba(231,177,231,0.7)' // 50% 处的颜色
		}, {
			offset: 0.51, color: 'rgba(231,177,231,0.5)' // 51% 处的颜色
		}, {
			offset: 1, color: 'rgba(231,177,231,0.5)' // 100% 处的颜色
		}],
	},
	{
		name: "长三角城市群",
		value: 999,
		color: [{
			offset: 0, color: 'rgba(230,162,60,0.1)' // 0% 处的颜色
		},{
			offset: 0.2, color: 'rgba(230,162,60,0.5)' // 20% 处的颜色
		}, {
			offset: 0.5, color: 'rgba(230,162,60,0.7)' // 50% 处的颜色
		}, {
			offset: 0.51, color: 'rgba(230,162,60,0.5)' // 51% 处的颜色
		}, {
			offset: 1, color: 'rgba(230,162,60,0.5)' // 100% 处的颜色
		}],
	},
	{
		name: "粤港澳大湾区",
		value: 999,
		color: [{
			offset: 0, color: 'rgba(58,194,175,0.1)' // 0% 处的颜色
		},{
			offset: 0.2, color: 'rgba(58,194,175,0.5)' // 20% 处的颜色
		}, {
			offset: 0.5, color: 'rgba(58,194,175,0.7)' // 50% 处的颜色
		}, {
			offset: 0.51, color: 'rgba(58,194,175,0.5)' // 51% 处的颜色
		}, {
			offset: 1, color: 'rgba(58,194,175,0.5)' // 100% 处的颜色
		}],
	},
]
let geo = {
	京津冀城市群: [116.46, 39.92],
	成渝经济圈: [104.06, 30.67],
	长三角城市群: [121.48, 31.22],
	粤港澳大湾区: [113.23, 23.16],
	飞渡: [119.5313, 29.8773]
}
let ourGeoData = [{
		name: "飞渡",
		value: 200,
	}]
export const convertToLineData = (data, gps) => {
    let res = [];
    for(let item of data) {
        let toCoord = geo[item.name];
        let fromCoord = gps;
        if (fromCoord && toCoord) {
            res.push([{
                coord: fromCoord,
                value: item.value,name:item.name
            }, {
                coord: toCoord,
            }]);
        }
    }
    return res;
}

export const convertData = (data) => {
    let res = [];
    for(let item of data) {
        let geoCoord = geo[item.name];
        if (geoCoord) {
            res.push({
                name: item.name,
                value: geoCoord.concat(item.value),
				color: item.color
            });
        }
    }
    return res;
}

export const getChartOption = (mapName) => {
    echarts.registerMap('china',mapData);
    let mapFeatures = echarts.getMap(mapName).geoJson.features;
    mapFeatures.forEach(v => {
        // 地区名称
        var name = v.properties.name;
        // 地区经纬度
        geoCoordMap[name] = v.properties.cp;

    });
    let option = {
        // tooltip: {
        //     trigger: 'item',
        //     show:true,
        //     formatter: function(params) {
        //         let toolTiphtml = '';
        //         let cityNum = params.value;
        //         if(isNaN(params.value)) {
        //             cityNum = 0
        //         }
        //         if(typeof(params.value) == 'object') {
        //             cityNum = params.value[2]
        //         }
        //         toolTiphtml += params.name + ':' + cityNum
        //         return toolTiphtml
        //     }
        // },
        geo: {
            show: true,
            map: mapName,
            label: {
                normal: {
                    show: false
                },
                emphasis: {
                    show: false,
                }
            },
            roam: false,
            itemStyle: {
                normal: {
                    areaColor: '#f2f2f2',
                    borderColor: '#3B5077',
                },
                emphasis: {
                    areaColor: '#e6eff6',
                }
            }
        },
        series: [
            {
                type: 'map',
                map: mapName,
                geoIndex: 0,
                aspectScale: 0.75, //长宽比
                showLegendSymbol: false, // 存在legend时显示
                label: {
                    normal: {
                        show: true
                    },
                    emphasis: {
                        show: false,
                        textStyle: {
                            color: '#fff'
                        }
                    }
                },
                roam: true,
                itemStyle: {
                    normal: {
                        areaColor: '#f2f2f2',
                        borderColor: '#3B5077',
                    },
                    emphasis: {
                        areaColor: '#f2f2f2'
                    }
                },
                animation: false,
                data: geoData
            },
            {
                name: 'Top 5',
                type: 'effectScatter',
                coordinateSystem: 'geo',
                data: convertData(geoData),    
                symbolSize: function(val) {
                    return val[2] / 10;
                },
                showEffectOn: 'render',
                rippleEffect: {
                    brushType: 'stroke'
                },
                hoverAnimation: true,
                label: {
                    normal: {
                        formatter: '{b}',
                        position: 'right',
                        show: true
                    }
                },
                itemStyle: {
                    normal: {
                        color: (params) => {
							let radial = {
								type: 'radial',
								x: 0.5,
								y: 0.5,
								r: 0.5,
								colorStops:params.data.color,
								global: false // 缺省为 false
							}
							return radial
						},
						// color: '#0098ed',
                        // shadowBlur: 50,
                        // shadowColor: 'rgba(233,105,105,1)'
                    }
                },
                zlevel: 1
            },
			{
                name: 'our',
                type: 'effectScatter',
                coordinateSystem: 'geo',
                data: convertData(ourGeoData),    
                symbolSize: function(val) {
                    return val[2] / 10;
                },
                showEffectOn: 'render',
                rippleEffect: {
                    brushType: 'stroke'
                },
                hoverAnimation: true,
                label: {
                    normal: {
                        formatter: '{b}',
                        position: 'right',
                        show: true
                    }
                },
                itemStyle: {
                    normal: {
						color: '#0098ed',
                        shadowBlur: 50,
                        shadowColor: '#0098ed'
                    }
                },
                zlevel: 2
            },
            {
                type: 'lines',
                zlevel: 3,
                label:{
                    show:false,
                },
                effect: {
                    show: true,
                    period: 4, //箭头指向速度，值越小速度越快
                    trailLength: 0.02, //特效尾迹长度[0,1]值越大，尾迹越长重
                    symbol: 'arrow', //箭头图标
                    symbolSize: 3, //图标大小
                },
                lineStyle: {
                    normal: {
                        color: '#0098ed',
                        width: 0.1, //尾迹线条宽度
                        opacity: 0.5, //尾迹线条透明度
                        curveness: .3 //尾迹线条曲直度
                    },
                },
                data: convertToLineData(geoData, [119.5313, 29.8773])
            },
        ]
    };
    return option
}


// WEBPACK FOOTER //
// ./src/components/index/index.js